export default () => {
  // The admin console shares this session; it re-bootstraps as the restored admin and must not be kicked.
  if (window.location.pathname.startsWith('/admin')) return;

  // localStorage is shared across tabs — clearing it here would wipe the admin console's `admin-state`.
  sessionStorage.clear();
  window.location.replace('/login');
};
